import React, { FC } from 'react';

import { TeamIcon } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

interface Props {
  name: string;
  isDropper?: boolean;
}

export const CalendarEmployeeInfo: FC<Props> = ({ name, isDropper }) => {
  const { t } = useTranslate();

  return (
    <div className="d-flex align-items-center mb-3">
      <TeamIcon color="#6C757D" size={20} className="me-2" />
      <span className="fw-500 me-1">{isDropper ? t('shiftSwaps.droppingEmployee') : t('calendar.employee')}:</span>
      {name}
    </div>
  );
};
